import type { ReactNode } from 'react';

export const symbol_ink_highlighter_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m741-823 112 112q17 17 16.5 45.5T852-620L657-425q-9.07 9-21.53 9-12.47 0-21.47-9-9-9-9-21t9-21l196-196-115-115-196 196q-8.8 9-20.9 9-12.1 0-21.1-9.21-9-9.22-9-21.5 0-12.29 9-21.29l198-198q17-17 43-17t43 17Zm97.16 747q-8.84 9-21 9T796-76L552-320 384-152q-19 19-52.5 19T279-152l-11-11-25 25q-8 8-19.37 13-11.38 5-23.63 5h-94q-9.52 0-13.26-9.5T96-146l94-94-4-4q-22-22-21.5-55.5T187-355l165-165L76-796q-9-8.8-9-20.9 0-12.1 8.84-21.1 8.84-9 21-9t21.16 9l720 720q9 9 9 21t-8.84 21ZM217-300l115 115 178-178-115-115-178 178Zm319-204Zm-84 84Z"
		/>
	</svg>
);
